import { render, staticRenderFns } from "./addSignNamePage.vue?vue&type=template&id=415ac03e&scoped=true"
import script from "./addSignNamePage.vue?vue&type=script&lang=js"
export * from "./addSignNamePage.vue?vue&type=script&lang=js"
import style0 from "./addSignNamePage.vue?vue&type=style&index=0&id=415ac03e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415ac03e",
  null
  
)

export default component.exports